import {
  Truck,
  KeyRound,
  CircleDot,
  BatteryCharging,
  Wrench,
  Zap,
} from "lucide-react";

export const SERVICES = [
  {
    id: "guincho",
    label: "Serviço de Guincho",
    subtitle: "reboque 24h",
    icon: Truck,
  },
  {
    id: "chaveiro",
    label: "Chaveiro Automotivo",
    subtitle: "abertura e chaves",
    icon: KeyRound,
  },
  {
    id: "borracharia",
    label: "Troca de Pneu",
    subtitle: "socorro móvel",
    icon: CircleDot,
  },
  {
    id: "bateria",
    label: "Carga de Bateria",
    subtitle: "auxiliar de partida",
    icon: BatteryCharging,
  },
  {
    id: "mecanico",
    label: "Auxílio Mecânico",
    subtitle: "reparos rápidos",
    icon: Wrench,
  },
  {
    id: "auto_eletrica",
    label: "Auxílio Pane Seca",
    subtitle: "combustível 24h",
    icon: Zap,
  },
];

export const SERVICE_BY_ID = SERVICES.reduce((acc, s) => {
  acc[s.id] = s;
  return acc;
}, {});
